"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.timeoutPromise = void 0;
var timeoutPromise = function (timeout, promise) {
    return new Promise(function (resolve, reject) {
        promise.then(resolve);
        setTimeout(function () {
            reject('timeout');
        }, timeout);
    });
};
exports.timeoutPromise = timeoutPromise;
//# sourceMappingURL=index.js.map